import { createAction, createReducer, createSelector } from '@reduxjs/toolkit'
import { AppState } from '../store'

export type SimulationType = 'ccam_code' | 'common_care'

export const changeSimulationType = createAction<SimulationType>(
  'simulation/changeType'
)
export const setSimulationCare = createAction<string>(
  'simulation/setSimulationCare'
)

export const setSsRate = createAction<number | null>('simulation/setSsRate')

export type InsuranceUnit = 'brss' | 'brss_ss'

export type SimulationState = {
  type: SimulationType
  selectedCareId: string | null
  am: boolean
  ald: boolean
  ssRate: number | null
  insuranceUnit: InsuranceUnit | null
}

const initialState: SimulationState = {
  type: 'ccam_code',
  selectedCareId: null,
  am: false,
  ald: false,
  ssRate: null,
  insuranceUnit: null,
}

export const simulationReducer = createReducer(initialState, builder => {
  builder.addCase(changeSimulationType, (state, action) => {
    state.type = action.payload
    state.selectedCareId = null
    state.ssRate = null
    state.insuranceUnit = null
  })
  builder.addCase(setSimulationCare, (state, action) => {
    state.selectedCareId = action.payload
    state.ssRate = null
    state.insuranceUnit = null
  })
  builder.addCase(setSsRate, (state, action) => {
    state.ssRate = action.payload
  })
})

export const selectSimulation = (state: AppState) => state.simulation

export const selectSelectedCareId = createSelector(
  selectSimulation,
  state => state.selectedCareId
)

export const selectType = createSelector(selectSimulation, state => state.type)

export const selectInsuranceUnit = createSelector(
  selectSimulation,
  state => state.insuranceUnit
)
